export default "__VITE_ASSET__CMe$bS$M__"